var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geofence-edit p-0 m-0 p-relative h-100"},[_c('div',{staticClass:"w-100",style:('height: ' + _vm.mapHeight()),attrs:{"id":"geofence-map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }